var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSvgBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 442,
    viewBox: "0 0 264 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 11.1C67.9 86 66.7 167.6 108 239.7c26.2 46 65.4 83.1 112.7 106.6a266.1 266.1 0 00-151 36c-68.4 39.8-109.6 107-130.3 177-1 3.4-2 6.7-2.8 10l-3 11.3 32.5 8.8a272.4 272.4 0 00207-26.5c63.7-37.1 115-127.3 133.2-193.5v-.2c17.4-66.5 18.1-170.1-18.6-234.2A272.5 272.5 0 00130.3 11l-41-11-3 11.1zm72.4 533.5c0-.1 0 0 0 0z",
    fill: "#5700FF"
  })));
}
export default SvgHeroSvgBottomRight;